<dx-load-panel
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  message="Chargement du lot en cours...">
</dx-load-panel>

<dx-popup
  id="dialog-ajout-lot"
  [(visible)]="displayDialog"
  [height]="'auto'"
  [width]="'auto'"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="lot-ajout-header">
    <div>
      <yo-icon icon="sign-out-alt"></yo-icon> <strong> Ajouter un lot</strong>
    </div>

    <div class="lot-ajout-actions">
      <yo-button iconClass="fas fa-save"
                 (onClick)="ajouterLot()"
                 [disabled]="isDisabledSaveBtn()"
                 tooltip="Enregistrer"
                 [theme]="ButtonThemeEnum.SAVE">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Fermer"
        (onClick)="closeDialog()"
        [theme]="ButtonThemeEnum.CANCEL">
      </yo-button>
    </div>
  </div>

  <section class="lot-ajout-content" [formGroup]="form">
    <div class="lot-ajout-content-left">
      <div class="lot-ajout-column">

        <span class="lot-ajout-section-title">
          <strong>DENRÉE (produit déclinaison)</strong>
        </span>

        <div class="lot-ajout-list">
          <div class="lot-ajout-row">
            <span>Nom</span>
            <yo-text-box
              [value]="produitDeclinaison?.libelle"
              [disabled]="true"
              [readonly]="true">
            </yo-text-box>
          </div>

          <div class="lot-ajout-row">
            <span>Code</span>
            <yo-text-box
              [value]="produitDeclinaison?.code"
              [disabled]="true"
              [readonly]="true">
            </yo-text-box>
          </div>

          <div class="lot-ajout-row">
            <span>Déclinaison</span>
            <yo-text-box
              [value]="produitDeclinaison?.declinaison?.libelle"
              [disabled]="true"
              [readonly]="true">
            </yo-text-box>
          </div>
        </div>
      </div>

      <div class="lot-ajout-column">

        <span class="lot-ajout-section-title">
          <strong>ARTICLE</strong> <span class="danger-color"> *</span>
        </span>

        <div class="lot-ajout-list">
          <div class="lot-ajout-row">
            <div>
              <span>Unité de production </span>
              <span class="danger-color">*</span>
            </div>
            <yo-lookup
              [data]="uniteProductionList"
              [selectedItem]="uniteProductionSelected?.id"
              (onValueChange)="onChangeUdp($event)">
            </yo-lookup>
          </div>

          <div class="lot-ajout-row">
            <span>Fournisseur</span>
            <yo-lookup
              [data]="fournisseurList"
              [selectedItem]="fournisseurSelected?.id"
              (onValueChange)="onChangeFournisseur($event)">
            </yo-lookup>
          </div>

          <div class="lot-ajout-row-dx-table">
            <dx-data-grid
              [dataSource]="catalogueAchatList"
              keyExpr="id"
              [hoverStateEnabled]="true"
              [allowColumnResizing]="true"
              [rowAlternationEnabled]="true"
              [columnAutoWidth]="false"
              [showRowLines]="true"
              [showBorders]="true"
              #grid>
              <dxi-column dataField="produitArticle.libelle" alignment="left" caption="Article" width="auto"
                          [allowFiltering]="true">
              </dxi-column>
              <dxi-column dataField="produitArticle.reference" alignment="left" caption="Référence" width="auto"
                          [allowFiltering]="true">
              </dxi-column>
              <dxi-column dataField="groupeAchatCaList" alignment="left" caption="Prix (UC)" width="auto"
                          [allowFiltering]="true"
                          cellTemplate="prixCellTemplate">
              </dxi-column>

              <div *dxTemplate="let cell of 'prixCellTemplate'">
                @for (groupeAchatCa of cell.row.data?.groupeAchatCaList; track groupeAchatCa.id) {
                  <div id="lot-ajout-cell-prix">
                    <input
                      type="radio"
                      id="group-name-Gaca"
                      [name]="'groupnameGaca'"
                      [checked]="selectedGacaViewModel?.id === groupeAchatCa.id"
                      (click)="updateGacaViewModel(groupeAchatCa, cell.row.data)">
                    @if (groupeAchatCa.prefere) {
                      <i title="Article préféré" class="fas fa-star"></i>
                    }
                    <div>
                      {{groupeAchatCa.prixUC | currency:'EUR':'symbol':'1.4-4'}}
                      / {{cell.row.data.uniteDeCommande.libelle | slice:0:5}}
                      <span
                        [title]="'Prix préférentiel lié au groupe : ' + groupeAchatCa.libelleGroupeAchat">
                        {{cell.row.data.groupeAchatCaList.length > 1 ? '(' + groupeAchatCa.libelleGroupeAchat + ')' : ''}}</span>
                    </div>
                  </div>
                }
              </div>

              <dxo-selection mode="single"></dxo-selection>
              <dxo-paging [pageSize]="25"></dxo-paging>
              <dxo-pager
                [visible]="true"
                [showPageSizeSelector]="true"
                [allowedPageSizes]="[25, 50, 100, 200]"
                [showNavigationButtons]="true"
                [showInfo]="true"
                infoText="{2} article(s)">
              </dxo-pager>
            </dx-data-grid>
          </div>
        </div>
      </div>
    </div>

    <div class="lot-ajout-column">

      <span class="lot-ajout-section-title">
        <strong>STOCK</strong>
      </span>

      <div class="lot-ajout-list">
        <div class="lot-ajout-row">
          <span>Zone de stockage <span class="danger-color">*</span></span>
          <yo-lookup
            [data]="zoneStockageList"
            [selectedItem]="zoneStockageSelected?.id"
            (onValueChange)="onChangeZoneStockage($event)">
          </yo-lookup>
        </div>

        <div class="lot-ajout-row">
          <span>Lot fabriquant</span>
          <yo-text-box
            id="lotFabriquant"
            [value]="form.controls['lotFabriquant'].value"
            (onValueChanged)="form.controls['lotFabriquant'].setValue($event)">
          </yo-text-box>
        </div>

        <div class="lot-ajout-row">
          <span>Date d'entrée</span>
          <dx-date-box
            id="selected-date"
            formControlName="dateEntree"
            [inputAttr]="{ 'aria-label': 'Date' }">
          </dx-date-box>
        </div>

        <div class="lot-ajout-row">
          <span>Quantité en US <span class="danger-color">*</span></span>
          <div class="lot-ajout-text-box">
            <yo-text-box
              id="quantite"
              [value]="form.controls['quantite'].value"
              (onValueChanged)="form.controls['quantite'].setValue($event)">
            </yo-text-box>
            @if (!utils.isNullOrEmpty(uniteDeStockage)) {
              <span><strong>{{this.uniteDeStockage?.abreviation}}</strong></span>
            }
          </div>
        </div>

        <div class="lot-ajout-row">
          <span>DLC/DDM</span>
          <dx-date-box
            id="dlc"
            formControlName="dlc"
            [inputAttr]="{ 'aria-label': 'Date' }">
          </dx-date-box>
        </div>

        <div class="lot-ajout-row">
          <span>Prix d'achat en UF</span>
          <div class="lot-ajout-text-box">
            <yo-text-box
              id="prixUnitaire"
              [value]="form.controls['prixUnitaire'].value"
              (onValueChanged)="form.controls['prixUnitaire'].setValue($event)">
            </yo-text-box>
            @if (!utils.isNullOrEmpty(uniteDeFacturation)) {
              <span><strong>€ / {{this.uniteDeFacturation?.abreviation}}</strong></span>
            }
          </div>
        </div>

        <div class="lot-ajout-row">
          <span>Images</span>
          <yo-button
            iconClass="fas fa-camera"
            [theme]="ButtonThemeEnum.ADD_INNER"
            (onClick)="openImageDialog()"
            tooltip="Ajouter une ou plusieurs photos"
            [label]="getImageCount()">
          </yo-button>
        </div>
      </div>
    </div>
  </section>
</dx-popup>

<yo-image-list-popup
  [isOpened]="isImagePopupOpened"
  (onClose)="onImagePopupClose($event)"
  [values]="this.stock.images">
</yo-image-list-popup>
